import { ActionType } from "./action-type";
export const Roles = [
    { key: "super-user", name: "SuperUser" },
    { key: "administrator", name: "Administrator" },
    { key: "power-user", name: "PowerUser" },
    { key: "basic-user", name: "BasicUser" },
    { key: "independent-user", name: "IndependentUser" },
    { key: "restricted-user", name: "RestrictedUser" },
    { key: "evergreen", name: "Evergreen" },
    { key: "evergreen-read-only", name: "EvergreenReadOnly" },
    { key: "internal-integration", name: "InternalIntegration" },
];
export const makeCustomRoleKey = (allowedActions) => {
    return `custom:${allowedActions.map(a => ActionType[a]).join(";")}`;
};
//# sourceMappingURL=role.js.map